import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {finalize, catchError} from 'rxjs/operators';
import {throwError} from 'rxjs';
import {SpinnerService} from '../services/spinner.service';

export const spinnerInterceptorFn: HttpInterceptorFn = (req, next) => {
    const spinnerService = inject(SpinnerService);
    spinnerService.show();

    return next(req).pipe(
        catchError((error) => {
            return throwError(error);
        }),
        finalize(() => {
            spinnerService.hide();
        })
    );
};
